/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */

 export default {
    numISNotNull: { SC:"数值不能为空", TC: "數值不能為空" , EN: "The value is required." }
    ,greaterThan: { SC:"数值错误,范围不能大于", TC: "數值錯誤，範圍不能大於", EN: "Value error, range cannot be greater than " }
    ,lessThan: { SC:"数值错误,范围不能小于", TC: "數值錯誤，範圍不能小於" , EN: "Value error, range should be greater than " }
    ,greaterThan0: { SC:"数值错误,范围应大于0", TC: "數值錯誤，範圍應大於0", EN: "Value error, range should be greater than 0." }
    ,sysfunc: { SC:"模块已被角色/我的最爱使用，请确定是否一并删除？", TC: "模塊已被角色/我的最愛使用，請確定是否一併删除？" , EN: "Function has been used by a character/my favorite, please confirm whether to delete it?" }
    ,save: { SC:"确定", TC: "確定", EN: "Confirm" }
    ,OffCallBack: { SC:"请传入关闭弹框的回调方法", TC: "請傳入關閉彈框的回檔方法", EN: "Please pass in the callback method to close the pop-up." }
    
}